import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.table(props => ({
    tableLayout: "fixed",
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).tables.border.color,
    width: 0,

    td: {
        verticalAlign: "baseline",
    },

    th: {
        ...theme(props).tables.headers.smallFont.css(),
        textAlign: "left",
    },
}));
